<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            @if (isPaymentForm() || isEduModalWidget() || isCartForm() || isModalForm()) {
                <div class="form-group mb-20">
                    @if (!isCartForm()) {
                        <label class="col-xs-9 control-label">
                            {{ "control_form_modal_background" | translate }}
                        </label>
                    }
                    @if (isCartForm()) {
                        <label class="col-xs-9 control-label">
                            {{ "control_form_background" | translate }}
                        </label>
                    }
                    <div class="col-xs-3">
                        @if (modalBackgroundColor() !== defaultModalBackgroundColor && !isCartForm()) {
                            <img
                                class="refresh-btn"
                                [tooltip]="refreshTooltip"
                                [tooltipAppendToBody]="true"
                                (click)="setModalBackgroundColor({ value: defaultModalBackgroundColor })"
                                src="./assets/img/websites/lpc-return-icon.svg"
                            />
                        }
                        <ng-template #refreshTooltip>
                            {{ "refresh_modal_background_color" | translate }}
                        </ng-template>
                        <sp-color-picker
                            [color]="modalBackgroundColor()"
                            [colorsPreset]="selectedThemeColors()"
                            (colorChangeEvent)="setModalBackgroundColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-6 control-label">
                        {{ "control_radius" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-input-num
                            prefixImgUrl="./assets/img/border-radius-icon.svg"
                            suffixText="px"
                            [min]="BORDER_RADIUS_MIN"
                            [max]="BORDER_RADIUS_MAX"
                            [value]="modalBorderRadius()"
                            (valueChange)="setModalBorderRadius($event)"
                            (blurEvent)="setModalBorderRadius($event)"
                        ></sp-input-num>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-7 control-label">
                        {{ "control_padding" | translate }}
                    </label>
                    <div class="col-xs-5">
                        <sp-input-num
                            suffixText="px"
                            [min]="PADDING_MIN"
                            [max]="PADDING_MAX"
                            [value]="modalPadding()"
                            (valueChange)="setModalPadding($event)"
                            (blurEvent)="setModalPadding($event)"
                        ></sp-input-num>
                    </div>
                </div>

                @if (!isCartForm() && !isModalForm()) {
                    <div class="form-group mb-20">
                        <label class="col-xs-9 control-label">
                            {{ "control_form_text_color" | translate }}
                        </label>
                        <div class="col-xs-3">
                            <sp-color-picker
                                [hideGradient]="true"
                                [colorsPreset]="selectedThemeColors()"
                                [color]="textColor()"
                                (colorChangeEvent)="setTextColor($event)"
                            ></sp-color-picker>
                        </div>
                    </div>
                }
                <div class="form-group mb-0">
                    <hr class="panel-options-divider" />
                </div>
            }

            @if ((isModalForm() && isTwoStepForm()) || !isModalForm()) {
                @if (isTwoStepForm()) {
                    <div class="form-group mb-0">
                        <div class="title">{{ "control_static_form_title" | translate }}</div>
                    </div>
                }

                @if (!isLoginForm() && !isCartForm()) {
                    <div class="form-group mb-20">
                        <label class="col-xs-9 control-label">
                            {{ "control_fields_name" | translate }}
                        </label>
                        <div class="col-xs-3 text-right control-switch">
                            <sp-switch
                                [active]="showLabels()"
                                (toggleActiveEvent)="setIsShowFieldsName($event)"
                            ></sp-switch>
                        </div>
                    </div>
                }

                @if (showLabels() && !(isPaymentForm() || isEduModalWidget())) {
                    <div class="form-group mb-20">
                        <label class="col-xs-9 control-label">
                            {{ "control_label_color" | translate }}
                        </label>
                        <div class="col-xs-3">
                            <sp-color-picker
                                [hideGradient]="true"
                                [colorsPreset]="selectedThemeColors()"
                                [color]="textColor()"
                                (colorChangeEvent)="setTextColor($event)"
                            ></sp-color-picker>
                        </div>
                    </div>
                }

                @if (!isPaymentForm() && !isLoginForm() && !isCartForm()) {
                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "control_fields_position" | translate }}
                        </label>
                        <div class="col-xs-12">
                            <div class="btn-group d-flex">
                                <button
                                    class="btn btn-grey w-100"
                                    [class.active]="formStyleType() === formStyleEnum.VERTICAL"
                                    (click)="setFormStyleType(formStyleEnum.VERTICAL)"
                                >
                                    <img src="./assets/img/websites/lpc-form-vertical-icon.svg" alt="vertical-form" />
                                </button>
                                <button
                                    class="btn btn-grey w-100"
                                    [class.active]="formStyleType() === formStyleEnum.HORIZONTAL"
                                    (click)="setFormStyleType(formStyleEnum.HORIZONTAL)"
                                >
                                    <img
                                        src="./assets/img/websites/lpc-form-horizontal-icon.svg"
                                        alt="horizontal-form"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                }

                <div class="form-group mb-20">
                    <label class="col-xs-12">
                        {{ "control_fields_appearance" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <div class="btn-group d-flex">
                            <button
                                class="btn btn-grey w-100"
                                [class.active]="inputBorderType() === inputBorderEnum.FULL_BORDER"
                                (click)="setInputBorderType(inputBorderEnum.FULL_BORDER)"
                            >
                                <img src="./assets/img/websites/lpc-full-border-icon.svg" alt="center-icon" />
                            </button>
                            <button
                                class="btn btn-grey w-100"
                                [class.active]="inputBorderType() === inputBorderEnum.BOTTOM_BORDER"
                                (click)="setInputBorderType(inputBorderEnum.BOTTOM_BORDER)"
                            >
                                <img src="./assets/img/websites/lpc-bottom-border-icon.svg" alt="left-icon" />
                            </button>
                        </div>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_input_text_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="inputTextColor()"
                            (colorChangeEvent)="setInputTextColor($event)"
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_background_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="backgroundColor()"
                            [colorsPreset]="selectedThemeColors()"
                            (colorChangeEvent)="setThemeBackgroundColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-6 control-label">
                        {{ "control_radius" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-input-num
                            prefixImgUrl="./assets/img/border-radius-icon.svg"
                            suffixText="px"
                            [class.disabled]="isDisabled()"
                            [min]="BORDER_RADIUS_MIN"
                            [max]="BORDER_RADIUS_MAX"
                            [value]="borderRadius()"
                            (valueChange)="setBorderRadius($event)"
                            (blurEvent)="setBorderRadius($event)"
                        ></sp-input-num>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_border_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="borderColor()"
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                            (colorChangeEvent)="setBorderColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="control-label col-xs-6">
                        {{ "control_fields_size" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-radio-group
                            [selected]="inputSize()"
                            [type]="radioGroupType.size"
                            (changeSelectedEvent)="setInputSize($event)"
                        ></sp-radio-group>
                    </div>
                </div>

                @if (isLoginForm()) {
                    <div class="form-group">
                        <label class="col-xs-9 control-label">
                            {{ "control_link_color" | translate }}
                        </label>
                        <div class="col-xs-3">
                            <sp-color-picker
                                [color]="linkColor()"
                                [hideGradient]="true"
                                [colorsPreset]="selectedThemeColors()"
                                (colorChangeEvent)="setLinkColor($event)"
                            ></sp-color-picker>
                        </div>
                    </div>
                }
            }

            @if (isModalForm()) {
                @if (isTwoStepForm()) {
                    <div class="form-group mb-0">
                        <hr class="panel-options-divider" />

                        <div class="title">{{ "control_modal_form_title" | translate }}</div>
                    </div>
                }

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_form_text_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                            [color]="modalTitleTextColor()"
                            (colorChangeEvent)="setModalTitleTextColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_fields_name" | translate }}
                    </label>
                    <div class="col-xs-3 text-right control-switch">
                        <sp-switch
                            [active]="modalShowLabels()"
                            (toggleActiveEvent)="setIsModalShowFieldsName($event)"
                        ></sp-switch>
                    </div>
                </div>

                @if (modalShowLabels()) {
                    <div class="form-group mb-20">
                        <label class="col-xs-9 control-label">
                            {{ "control_label_color" | translate }}
                        </label>
                        <div class="col-xs-3">
                            <sp-color-picker
                                [hideGradient]="true"
                                [colorsPreset]="selectedThemeColors()"
                                [color]="modalTextColor()"
                                (colorChangeEvent)="setModalTextColor($event)"
                            ></sp-color-picker>
                        </div>
                    </div>
                }

                <div class="form-group mb-20">
                    <label class="col-xs-12">
                        {{ "control_fields_appearance" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <div class="btn-group d-flex">
                            <button
                                class="btn btn-grey w-100"
                                [class.active]="modalInputBorderType() === inputBorderEnum.FULL_BORDER"
                                (click)="setModalInputBorderType(inputBorderEnum.FULL_BORDER)"
                            >
                                <img src="./assets/img/websites/lpc-full-border-icon.svg" alt="center-icon" />
                            </button>
                            <button
                                class="btn btn-grey w-100"
                                [class.active]="modalInputBorderType() === inputBorderEnum.BOTTOM_BORDER"
                                (click)="setModalInputBorderType(inputBorderEnum.BOTTOM_BORDER)"
                            >
                                <img src="./assets/img/websites/lpc-bottom-border-icon.svg" alt="left-icon" />
                            </button>
                        </div>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_input_text_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="modalInputTextColor()"
                            (colorChangeEvent)="setModalInputTextColor($event)"
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_background_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="modalInputBackgroundColor()"
                            [colorsPreset]="selectedThemeColors()"
                            (colorChangeEvent)="setThemeModalInputBackgroundColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-6 control-label">
                        {{ "control_radius" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-input-num
                            prefixImgUrl="./assets/img/border-radius-icon.svg"
                            suffixText="px"
                            [class.disabled]="isDisabled()"
                            [min]="BORDER_RADIUS_MIN"
                            [max]="BORDER_RADIUS_MAX"
                            [value]="modalInputBorderRadius()"
                            (valueChange)="setModalInputBorderRadius($event)"
                            (blurEvent)="setModalInputBorderRadius($event)"
                        ></sp-input-num>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_border_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="modalInputBorderColor()"
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                            (colorChangeEvent)="setModalInputBorderColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group">
                    <label class="control-label col-xs-6">
                        {{ "control_fields_size" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-radio-group
                            [selected]="modalInputSize()"
                            [type]="radioGroupType.size"
                            (changeSelectedEvent)="setModalInputSize($event)"
                        ></sp-radio-group>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
